import http from "../utils/axios";

// 获取产品详情接口
export const getProductDetail = data => {
  return http({
    url: "/api/client_product/getProductDetail", // 接口
    method: "post",
    data: data
  });
};
// 投保
//
//获取是否固定投保人接口
export const getPolicyHolder = data => {
  return http({
    url: "/api/order/getPolicyHolder", // 接口
    method: "post",
    data: data
  });
};
// 获取保障期限、起保日期接口
export const getProductTimeRule = data => {
  return http({
    url: "/api/client_product/getProductTimeRule", // 接口
    method: "post",
    data: data
  });
};
// 获取保障期限、起保日期接口
export const getWorkType = data => {
  return http({
    url: "/api/client_product/getWorkType", // 接口
    method: "post",
    data: data
  });
};
// 根据职业类别获取工种接口
export const getWork = data => {
  return http({
    url: "/api/client_product/getWork", // 接口
    method: "post",
    data: data
  });
};
// 获取产品方案接口
export const getProductPlan = data => {
  return http({
    url: "/api/client_product/getProductPlan", // 接口
    method: "post",
    data: data
  });
};
// 获取保费接口
export const getProductPlanMoney = data => {
  return http({
    url: "/api/client_product/getProductPlanMoney", // 接口
    method: "post",
    data: data
  });
};
// 投保接口
export const createOrder = data => {
  return http({
    url: "/api/order/createOrder", // 接口
    method: "post",
    data: data
  });
};
// 投保接口//车险
export const createCarOrder = data => {
  return http({
    url: "/api/order/createCarOrder", // 接口
    method: "post",
    data: data
  });
};
// 获取地区库接口
export const getAreaList = data => {
  return http({
    url: "/api/common/getAreaList", // 接口
    method: "post",
    data: data
  });
};
// 获取地区库接口
export const getPersonList = data => {
  return http({
    url: "/api/order/getPersonList", // 接口
    method: "post",
    data: data
  });
};

// 上传投保资料接口
export const uploadInsureFile = data => {
  return http({
    url: "/api/order/uploadInsureFile", // 接口
    method: "post",
    data: data
  });
};
// 保单支付接口
export const policyPay = data => {
  return http({
    url: "/api/order/policyPay", // 接口
    method: "post",
    data: data
  });
};
// 获取常用投保人接口
export const getApplicationList = data => {
  return http({
    url: "/api/user/getApplicationList", // 接口
    method: "post",
    data: data
  });
};
// 获取常用被保人接口
export const getInsuredList = data => {
  return http({
    url: "/api/user/getInsuredList", // 接口
    method: "post",
    data: data
  });
};

export const getAllWorkTypeSelect = data => {
    return http({
      url: "/api/work/getAllWorkTypeSelect", // 接口
      method: "post",
      data: data
    });
  };